import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {IUserDataNormalizedClient, IUserProfileBase} from "../define";

export const GetUserProfileUrl = `/get_user_profile`;
export const GetUserProfileMethod = ERequestType.TYPE_GET;

export interface GetUserProfileRequest extends ApiRequest {
	userId?: string;
	email?: string;
}

export interface GetUserProfileResponse<IProfile extends IUserProfileBase> extends ApiResponse {
	user: IUserDataNormalizedClient<IProfile>;
}
